<!-- <app-notification-bar></app-notification-bar> -->
<div
  class="notd__grid wrapper--centered"
  [ngClass]="{'pwa-app': pwdApp}">
  <a class="notd-logo" [routerLink]="['/']" title="Notd.io">
    <img data-cy="notd-logo" src="../../assets/logo-black.png" alt="Notd.io">
  </a>

  <div class="right-menu-section">
    <search-content
      data-cy="search-input-header"
      class="content-search-input"
      [props]="searchFormProps"
      *ngIf="searchShowTrigger"
      type="notes"></search-content>
    <a title="Search" *ngIf="searchShowTrigger" (click)="isCollapsed = !isCollapsed" class="mobile-search">
      <svg
        version="1.1" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" class="ng-element" data-id="ae3119987b3269ea978f2a065d929425" style="fill: rgb(0, 0, 0); width: 30px; height: 32px; pointer-events: all; filter: none;" xmlns="http://www.w3.org/2000/svg"><g>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" style="fill: rgb(0, 0, 0);"/></g>
      </svg>
    </a>
    <ul class="desktop-menu">
      <li class="nav-item">
        <a title="Latest on Notd" data-cy="header-explore" class="explore-link" [routerLink]="['/search/all/all']">Latest</a>
      </li>
      <li class="nav-item">
        <a title="About Us" data-cy="about-header" class="about-us-link" [routerLink]="['/about']">About Us</a>
      </li>
      <li class="nav-item">
        <a title="Contact" data-cy="contact-header" class="contact-link" (click)="openContactModal()">Contact</a>
      </li>
      <li class="nav-item" *ngIf="!isLoggedIn">
        <a title="Sign-up or Login" data-cy="sign-up-login-header" transact-auth [partnersModal]="notdPartnersModal">Sign-up or Login</a>
        <notd-partners-modal
          #notdPartnersModal
          [splitButtons]="true"
          [buttonLabel]="'Sign-up or Login'"
          [customReturnUrl]="{signup: {enable: true, url: 'info/signup-thankyou'}}"></notd-partners-modal>
      </li>
    </ul>
    <create-note [onlyButton]="true"></create-note>
    <user-earnings-counter *ngIf="isLoggedIn"></user-earnings-counter>
    <notification-button *ngIf="isLoggedIn"></notification-button>
    <button class="header-menu-toggle"
            (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed"
            type="button"
            aria-expanded="false"
            aria-label="Toggle navigation">
      <fa-icon [icon]="['fas', 'bars']"></fa-icon>
    </button>
    <user-menu
      [triggerMenu]="isCollapsed"
      (logOutEvent)="logOut()"
      (mobileMenuEvent)="toggleMobileMenu()"
      (openContactModalEvent)="openContactModal()"
      [user]="user"></user-menu>
    <div class="header__mobile-menu">
      <create-note
        [onlyButton]="true"
        [miniButton]="true"></create-note>
      <a
        title="Search for content"
        (click)="onShowSearchModal()"
        class="header__mobile-menu__link search-icon"
        [ngClass]="{'search--visible': showSearchBar}">
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M464,428,339.92,303.9a160.48,160.48,0,0,0,30.72-94.58C370.64,120.37,298.27,48,209.32,48S48,120.37,48,209.32s72.37,161.32,161.32,161.32a160.48,160.48,0,0,0,94.58-30.72L428,464ZM209.32,319.69A110.38,110.38,0,1,1,319.69,209.32,110.5,110.5,0,0,1,209.32,319.69Z"/></svg>
      </a>
    </div>
  </div>
</div>
<div class="header__mobile-submenu" #mobileSubmenu>
  <ul class="header__mobile-submenu__list">
    <li class="header__mobile-submenu__list__element">
      <a
        [routerLink]="['/m', 'latest']"
        routerLinkActive="active"
        [class.active]="isMainPageUrl"
        title="Home"
        class="header__mobile-submenu__list__element__link">
          <svg enable-background="new 0 0 48 48" version="1.1" viewBox="0 0 48 48" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Expanded"><g><g><path d="M42,48H28V35h-8v13H6V27c0-0.552,0.447-1,1-1s1,0.448,1,1v19h10V33h12v13h10V28c0-0.552,0.447-1,1-1s1,0.448,1,1V48z"/></g><g><path d="M47,27c-0.249,0-0.497-0.092-0.691-0.277L24,5.384L1.691,26.723c-0.399,0.381-1.032,0.368-1.414-0.031     c-0.382-0.399-0.367-1.032,0.031-1.414L24,2.616l23.691,22.661c0.398,0.382,0.413,1.015,0.031,1.414     C47.526,26.896,47.264,27,47,27z"/></g><g><path d="M39,15c-0.553,0-1-0.448-1-1V8h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h8v8C40,14.552,39.553,15,39,15z"/></g></g></g></svg>
      </a>
    </li>
    <li
      *ngIf="isLoggedIn"
      class="header__mobile-submenu__list__element">
      <a
        [routerLink]="['/user', user.id, 'my-account']"
        title="User pofile"
        class="header__mobile-submenu__list__element__link user--avatar">
          <img
            *ngIf="user.profileImageUrl"
            class="header__mobile-submenu__list__element__link link--user"
            src="{{user.profileImageUrl}}">
          <svg *ngIf="!user.profileImageUrl" enable-background="new 0 0 50 50" id="Layer_1" version="1.1" viewBox="0 0 50 50" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="25" cy="25" fill="none" r="24" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/><rect fill="none" height="50" width="50"/><path d="M29.933,35.528  c-0.146-1.612-0.09-2.737-0.09-4.21c0.73-0.383,2.038-2.825,2.259-4.888c0.574-0.047,1.479-0.607,1.744-2.818  c0.143-1.187-0.425-1.855-0.771-2.065c0.934-2.809,2.874-11.499-3.588-12.397c-0.665-1.168-2.368-1.759-4.581-1.759  c-8.854,0.163-9.922,6.686-7.981,14.156c-0.345,0.21-0.913,0.878-0.771,2.065c0.266,2.211,1.17,2.771,1.744,2.818  c0.22,2.062,1.58,4.505,2.312,4.888c0,1.473,0.055,2.598-0.091,4.21c-1.261,3.39-7.737,3.655-11.473,6.924  c3.906,3.933,10.236,6.746,16.916,6.746s14.532-5.274,15.839-6.713C37.688,39.186,31.197,38.93,29.933,35.528z" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/></svg>
      </a>
    </li>
    <li class="header__mobile-submenu__list__element">
      <a
        [routerLink]="['/m', 'popular']"
        routerLinkActive="active"
        title="Most popular streams"
        class="header__mobile-submenu__list__element__link">
          <svg version="1.1" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><desc/><defs/><g fill="none" fill-rule="evenodd" id="People" stroke="none" stroke-width="1"><g fill="#000000" id="Icon-1"><path d="M5,14 C4.448,14 4,14.448 4,15 L4,49 C4,49.552 4.448,50 5,50 C5.552,50 6,49.552 6,49 L6,15 C6,14.448 5.552,14 5,14 L5,14 Z M22,22 C22,23.103 22.897,24 24,24 C25.103,24 26,23.103 26,22 C26,20.897 25.103,20 24,20 C22.897,20 22,20.897 22,22 L22,22 Z M18,31 C18,31.552 18.448,32 19,32 L25,32 C25.265,32 25.52,31.895 25.707,31.707 L32,25.414 L34.293,27.707 C34.684,28.098 35.316,28.098 35.707,27.707 L40,23.414 L44.293,27.707 C44.684,28.098 45.316,28.098 45.707,27.707 C46.098,27.316 46.098,26.684 45.707,26.293 L40.707,21.293 C40.316,20.902 39.684,20.902 39.293,21.293 L35,25.586 L32.707,23.293 C32.316,22.902 31.684,22.902 31.293,23.293 L24.586,30 L20,30 L20,18 L48,18 L48,30 L31,30 C30.448,30 30,30.448 30,31 C30,31.552 30.448,32 31,32 L49,32 C49.552,32 50,31.552 50,31 L50,17 C50,16.448 49.552,16 49,16 L19,16 C18.448,16 18,16.448 18,17 L18,31 Z M47,48 L37,48 C36.448,48 36,48.448 36,49 C36,49.552 36.448,50 37,50 L47,50 C47.552,50 48,49.552 48,49 C48,48.448 47.552,48 47,48 L47,48 Z M19,50 L29,50 C29.552,50 30,49.552 30,49 C30,48.448 29.552,48 29,48 L19,48 C18.448,48 18,48.448 18,49 C18,49.552 18.448,50 19,50 L19,50 Z M47,42 L37,42 C36.448,42 36,42.448 36,43 C36,43.552 36.448,44 37,44 L47,44 C47.552,44 48,43.552 48,43 C48,42.448 47.552,42 47,42 L47,42 Z M19,44 L31,44 C31.552,44 32,43.552 32,43 C32,42.448 31.552,42 31,42 L19,42 C18.448,42 18,42.448 18,43 C18,43.552 18.448,44 19,44 L19,44 Z M50,37 C50,36.448 49.552,36 49,36 L37,36 C36.448,36 36,36.448 36,37 C36,37.552 36.448,38 37,38 L49,38 C49.552,38 50,37.552 50,37 L50,37 Z M49,12 C49.552,12 50,11.552 50,11 C50,10.448 49.552,10 49,10 L45,10 C44.448,10 44,10.448 44,11 C44,11.552 44.448,12 45,12 L49,12 Z M19,12 L35,12 C35.552,12 36,11.552 36,11 C36,10.448 35.552,10 35,10 L19,10 C18.448,10 18,10.448 18,11 C18,11.552 18.448,12 19,12 L19,12 Z M19,38 L29,38 C29.552,38 30,37.552 30,37 C30,36.448 29.552,36 29,36 L19,36 C18.448,36 18,36.448 18,37 C18,37.552 18.448,38 19,38 L19,38 Z M60,5 L60,51 C60,56.551 56.551,60 51,60 L9,60 C3.449,60 0,56.551 0,51 L0,13 C0,10.243 2.243,8 5,8 C5.552,8 6,8.448 6,9 C6,9.552 5.552,10 5,10 C3.346,10 2,11.346 2,13 L2,51 C2,55.449 4.551,58 9,58 L51,58 C55.449,58 58,55.449 58,51 L58,5 C58,3.346 56.654,2 55,2 L13,2 C11.402,2 10,3.402 10,5 L10,53 C10,53.552 9.552,54 9,54 C8.448,54 8,53.552 8,53 L8,5 C8,2.29 10.29,0 13,0 L55,0 C57.757,0 60,2.243 60,5 L60,5 Z" id="newspaper"/></g></g></svg>
      </a>
    </li>
    <li
      *ngIf="!isLoggedIn"
      class="header__mobile-submenu__list__element">
      <a
        transact-auth
        [partnersModal]="notdPartnersModal"
        title="User pofile"
        class="header__mobile-submenu__list__element__link">
          <notd-partners-modal #notdPartnersModal></notd-partners-modal>
          <svg enable-background="new 0 0 50 50" id="Layer_1" version="1.1" viewBox="0 0 50 50" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="25" cy="25" fill="none" r="24" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/><rect fill="none" height="50" width="50"/><path d="M29.933,35.528  c-0.146-1.612-0.09-2.737-0.09-4.21c0.73-0.383,2.038-2.825,2.259-4.888c0.574-0.047,1.479-0.607,1.744-2.818  c0.143-1.187-0.425-1.855-0.771-2.065c0.934-2.809,2.874-11.499-3.588-12.397c-0.665-1.168-2.368-1.759-4.581-1.759  c-8.854,0.163-9.922,6.686-7.981,14.156c-0.345,0.21-0.913,0.878-0.771,2.065c0.266,2.211,1.17,2.771,1.744,2.818  c0.22,2.062,1.58,4.505,2.312,4.888c0,1.473,0.055,2.598-0.091,4.21c-1.261,3.39-7.737,3.655-11.473,6.924  c3.906,3.933,10.236,6.746,16.916,6.746s14.532-5.274,15.839-6.713C37.688,39.186,31.197,38.93,29.933,35.528z" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/></svg>
      </a>
    </li>
    <li class="header__mobile-submenu__list__element" *ngIf="isLoggedIn">
      <a
        (click)="toggleNotifications()"
        title="Notifications"
        [ngClass]="{'has-notifications': !userHasNotification}"
        class="header__mobile-submenu__list__element__link link--notification">
          <svg class="bell" fill="none" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 8.4C18 6.70261 17.3679 5.07475 16.2426 3.87452C15.1174 2.67428 13.5913 2 12 2C10.4087 2 8.88258 2.67428 7.75736 3.87452C6.63214 5.07475 6 6.70261 6 8.4C6 15.8667 3 18 3 18H21C21 18 18 15.8667 18 8.4Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </a>
    </li>
    <li>
      <a
        (click)="toggleMobileMenu()"
        title="Main menu"
        class="header__mobile-submenu__list__element__link">
        <svg data-name="Layer 1" id="Layer_1" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><line class="cls-1" x1="1" x2="47" y1="10" y2="10"/><line class="cls-1" x1="1" x2="47" y1="24" y2="24"/><line class="cls-1" x1="1" x2="47" y1="38" y2="38"/></svg>
      </a>
    </li>
  </ul>
</div>
<a (click)="historyBack()"
   *ngIf="pwdApp"
   class="back-button">
  <fa-icon [icon]="['fas', 'angle-double-left']"></fa-icon>
</a>


<ng-template #searchModal let-c="close" let-d="dismiss">
  <a (click)="d('Cross click')" data-cy="close-modal" class="search-modal__close-btn" title="Close Search Window">
      <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
  </a>
  <h2 class="search-modal__title">
      Search for content
  </h2>
  <section class="search-modal__content">
    <search-content
      [props]="searchFormProps"
      [isPreviewMode]="false"
      [previewDefaultPhase]="'notd'"
      (searchTriggered)="mobileSearchTriggered($event)"
      type="notes"></search-content>
    <h2 class="search-modal__content__default__headline">Also Worth to see</h2>
    <div
        *ngIf="categories && categories.length"
        class="search-modal__content__default__others">
        <a
          *ngFor="let c of categories"
          (click)="d('Cross click')"
          [routerLink]="['/search', 'all', c.cat]"
          [title]="c.label">{{c.label}}</a>
    </div>
  </section>
  <button
    type="button"
    class="search-modal__content__button--close notd__button--v2 button--green"
    (click)="d('Cross click')">Close window</button>
</ng-template>

<share-button
  [contentElRef]="notdScreenElement"
  [shareContent]="{title: 'Check out the content on Notd.io!', message: 'Don`t wait! Just read and create your content on Notd.io for free!' }"></share-button>

<section
  class="share-img-content"
  #shareImgContent>
  <img class="share-img-content__logo" src="../../assets/logo-black.png" alt="Notd.io">
  <h1>
    Finally! A Fully Customizable, Ad-Free News and Information Network
  </h1>
  <h2>
    Notd is a revolutionary publishing network: a go-to source for unbiased news, podcasts, newsletters, poetry, and more.
  </h2>
</section>
